export const clothDiaperKey = 'web_fab_friday';
export const clothDiaperKeyDuplicate = 'web_fab_friday_2';
export const bestClothDiaperKey = 'web_fab_friday_b';
export const summerStoreKey = 'web_summer_store';
export const tuesdaySaleKey = 'web_happy_tuesday';
export const jawDroppingDiscountKey = 'web_happy_tuesday_new';
export const bogoPageKey = 'web_bogo_store';
export const mothersDayStoreKey = 'web_cred';
export const pregnancyPlanningTagId = 1929;
export const PregnancyPlanningKey = 'ttc_web';
export const infantTagId = 1931;
export const infantKey = 'mother_web';
export const pregnantTagId = 1919;
export const pregnantKey = 'pregnant_web';
export const toddlerTagId = 1926;
export const toddlerKey = 'toddler_web';
export const stageToddler = 'toddler';
export const stageInfant = 'mother';
export const stagePregnancy = 'pregnant';
export const stagePregnancyPlanning = 'ttc';
export const ivfTreatmentKey = 'web_ivf_treament';
export const happy20 = 'web_happy_20';
export const maternityWear = 'web_maternity_wear';
export const Happiness2x = '2xhappiness_bogo';
export const lactoMamaKey = 'web_lactomama_page';
export const clothDiaperNewKey = 'web_b2g1_cd_new';
export const stretchMarksKey = 'web_stretch_marks_care';
export const breastFeedingKey = 'web_breastfeeding_week';
